import axios from "axios";
import { urls } from "../../config/constants";
const createCompany = async (data) => {
  try {
    const response = await axios.post(`${urls.api}/companies`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating company:", error);
    return null;
  }
};

const sendInvitations = async (data) => {
  console.log("DATA", data);
  try {
    const response = await axios.post(`${urls.api}/invitations`, data);
    return response.data;
  } catch (error) {
    console.error("Error sending invitations:", error);
    throw error;
  }
};

export { createCompany, sendInvitations };
